import './AdministrativeClients.css';
import React, {useState} from "react";
import {useGetClients} from "../../../hooks/Administrative/useGetClients";
import ClientsTableView from "../../../components/ClientsTableView/ClientsTableView";
import AddClient from "../../../components/AddClient/AddClient";
import {useGetClientFilters} from "../../../hooks/Administrative/useGetClientFilters";
import ClientInfo from "../../../components/ClientInfo/ClientInfo";

const columns = ['NOMBRE', 'ATC', 'ESTADO', 'CLAVE'];

const AdministrativeClients = () => {
    const [filters, setFilters] = useState({});
    const {clients, totalPages, isLoading, page, setPage, addClientLocally} = useGetClients({filters});
    const [showAddClient, setShowAddClient] = useState(false);
    const {salesreps, states} = useGetClientFilters();
    const [showClientInfo, setShowClientInfo] = useState(false);
    const [selectedClientUniqueCode, setSelectedClientUniqueCode] = useState<string>('');
    const [additionalInfo, setAdditionalInfo] = useState<any>(null);

    const handleAddClient = () => {
        setShowAddClient(true);
    }

    const onHandleBack = () => {
        setShowAddClient(false);
        setShowClientInfo(false);
    }

    const handleOnRowClick = (row: Record<string, any>) => {
        setSelectedClientUniqueCode(row['CLAVE']);
        setAdditionalInfo(row);
        setShowClientInfo(true);
    };

    return (
        <div className="clients-wrapper">
            {showClientInfo ? (
                <ClientInfo
                    clientUniqueCode={selectedClientUniqueCode}
                    onBack={onHandleBack}
                    additionalInfo={additionalInfo}/>
                ) : (
                <>
                    {showAddClient ? (
                        <AddClient onHandleBack={onHandleBack} addClientLocally={addClientLocally}/>
                    ) : (
                        <ClientsTableView
                            title="CLIENTES"
                            columns={columns}
                            clientsInfo={clients}
                            totalPages={totalPages}
                            isLoading={isLoading}
                            page={page}
                            salesreps={salesreps}
                            states={states}
                            setFilters={setFilters}
                            setPage={setPage}
                            disableAddButton={false}
                            handleAdd={handleAddClient}
                            onRowClick={handleOnRowClick}
                        />
                    )}
                </>
            )}

        </div>
    );
};

export default AdministrativeClients;
